import React from "react";
import styled from "styled-components";

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 16px 80px;
  ${({ theme }) => theme.media.tabletUp`
    padding: 0;
    padding-bottom: 56px;
  `};
`;

const CardWrapper = styled.div`
  width: 100%;
  margin-bottom: 16px;
  ${({ theme }) => theme.media.tabletUp`
    width: 50%;
  `};
  &:nth-child(odd) {
    ${({ theme }) => theme.media.tabletUp`
      padding-right: 8px;
    `};
  }

  &:nth-child(even) {
    ${({ theme }) => theme.media.tabletUp`
      padding-left: 8px;
    `};
  }
`;

const LargeHubCardContainer = ({ children }) => {
  return (
    <CardContainer>
      {children.map((child, index) => {
        return <CardWrapper key={index}>{child}</CardWrapper>;
      })}
    </CardContainer>
  );
};

export default LargeHubCardContainer;
